module.exports = __webpack_public_path__ + "static/img/pingtai.11a2af7b.png";